var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "badge-icon pointer",
    on: {
      "click": function click($event) {
        return _vm.showNotificationPanel();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary desktop",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1a_icons8-chat-room.svg",
      "loading": "lazy",
      "alt": ""
    }
  }), _vm.allUnseenMessages !== 0 ? _c('div', {
    staticClass: "div-block-85"
  }, [_c('div', [_vm._v(_vm._s(_vm.allUnseenMessages))])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }